import { FC } from "react"
import { MainLayout } from "./MainLayout"

export const ReportsPage: FC = () => {
  return <MainLayout>reports page</MainLayout>
}
